import { theme } from '@frontend/theme';
import { styles, SpinningLoader } from '@frontend/design-system';

export const InsuranceLoader = () => {
  return (
    <div css={[styles.flexCenter, { padding: theme.spacing(2) }]}>
      <SpinningLoader size='small' />
    </div>
  );
};
